import { createSlice } from '@reduxjs/toolkit';

import { incomingMessageReceived } from '@/store/actions/poc/incomingMessageReceived';
import type { MessageHandlerResult } from '@/services/abstract/poc/MessagingService';

const MAX_RECENT_MESSAGES = 100;

export interface MessagingState {
  recentMessages: MessageHandlerResult[];
  stats: {
    totalReceived: number;
    lastReceivedAt: number | null;
  };
}

const initialState: MessagingState = {
  recentMessages: [],
  stats: { totalReceived: 0, lastReceivedAt: null },
};

const messagingSlice = createSlice({
  name: 'messaging',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(incomingMessageReceived, (state, action) => {
      state.recentMessages = [
        ...state.recentMessages.slice(-(MAX_RECENT_MESSAGES - 1)),
        action.payload.result,
      ];
      state.stats.totalReceived += 1;
      state.stats.lastReceivedAt = action.payload.stats.timestamp;
    });
  },
});

export default messagingSlice.reducer;
